<template>
  <div>
    <q-dialog :visible="isVisible" :title="title" width="50%" :innerScroll="false" :showFooter="false" @close="onCancel">
      <div v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading">
        <div class="header">
          <div>
            <el-button
              type="primary"
              size="mini"
              @click="importExcel"
              v-show="sectionImportShow"
              v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$sectionImportBth'"
              >上传
            </el-button>
            <el-button
              type="primary"
              size="mini"
              @click="openUploadProgress"
              >上传进度
            </el-button>
            <el-button
              type="warning"
              size="mini"
              @click="handleModifyVoidClick"
              v-show="isShowVoidBtn"
              >修改作废
              <el-tooltip content="如之前修改并通知的设计图需要重新调整修改，可点击此按钮，系统将通知店铺对之前修改的设计图进行作废；" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-button>
          </div>
          <div>
            <span>切片上传规则：</span>
            <el-popover placement="left-start" title="" width="500" trigger="click">
              <div class="popoverBOx">
                <h4>1、上传说明：</h4>
                <p>①成功上传切片后，此SPU切片节点则自动完成；</p>
                <h4>2、上传类型说明：</h4>
                <p>①首次：第一次上传切片默认为首次，并不可更改其他类型；</p>
                <p>②非首次（包含多种类型）：非首次上传切片，需回退至“切片”节点后才可选择这些类型；</p>
                <h4>3、上传文件夹格式说明：</h4>
                <p>①上传文件夹的名称必须为当前“SPU名称”；</p>
                <!-- <p>②上传文件夹下的二级目录必须存在“切片”和“主图”两个文件夹；</p>
                <p>③“主图”文件夹限制：</p>
                <p>a、主图下“透明白底”和“唯品会”文件夹下支持“PNG和JPG”图片格式;</p>
                <p>b、其他文件夹格式必须为JPG；</p>
                <p>④“切片”文件夹限制： 切片下的文件夹里面的图片格式必须为“GIF”和“JPG”；</p>
                <h4>4、上传文件夹格式-首次说明：</h4>
                <p>①参照“第3点”；</p>
                <h4>5、上传文件夹格式-非首次说明：</h4>
                <p>①上传类型为“文件夹新增”：</p>
                <p>a、新增的文件夹不允许在选择文件夹路径下与其他“文件夹"名称一致;</p>
                <p>②上传类型为“改工艺、改色差、尺寸材质调整，其他-修改”：</p>
                <p>a、 选择一级文件夹的名称必须为当前“SPU名称”；</p>
                <p>b、上传的文件夹名称、文件夹数量、所有图片名称和数量必须一致；</p>
                <h4>6、上传图片格式说明：</h4>
                <p>①上传类型为“直播-新增”和“其他-新增”：</p>
                <p>a、新增的图片不允许在选择文件夹路径下其他“图片”名称一致；</p>
                <p>②上传类型为“改工艺、改色差、尺寸材质调整，其他-修改”：</p>
                <p>a、上传的图片名称必须为选择文件夹路线下已有图片名称；</p> -->
              </div>
              <el-button type="text" slot="reference">点击查看</el-button>
            </el-popover>
          </div>
        </div>
        <el-table
          :data="tableData"
          v-if="tableReload"
          border
          height="320px"
          :header-cell-style="{
            backgroundColor: '#FAFAFA',
            textAlign: 'center',
          }"
          :cell-style="{ textAlign: 'center' }"
          style="width: 100%"
        >
          <el-table-column prop="folderName" label="文件名" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="uploadDate" label="更新时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="bookTime" label="操作" :show-overflow-tooltip="true">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                @click="download(row)"
                v-show="title == '切片'"
                v-permission="'ec-pc-new$productLifeCycle$aboutNew$NewProductDetail$sectionDownload'"
                >下载</el-button
              >
            </template>
          </el-table-column>
          <el-table-column width="55" label="" type="expand">
            <template slot-scope="scope">
              <el-table :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }" :data="scope.row.detailVOList" border>
                <el-table-column prop="folderName" label="类型" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="imgNum" label="数量" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="updatedDate" label="更新时间" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="name" label="操作人" :show-overflow-tooltip="true"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </q-dialog>
    <q-dialog
      :visible="isVisibleImport"
      v-if="isVisibleImport"
      title="上传"
      width="860px"
      :innerScroll="false"
      :showFooter="false"
      @cancel="onCancelImport"
      @close="onCancelImport"
    >
      <div v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" style="padding: 20px 0">
        <el-form :model="requestParam" :rules="rules" ref="requestParam" label-width="100px" size="mini" class="content">
          <el-row>
            <el-col :span="24">
              <el-form-item label="大型号:" prop="bigModel">
                <span v-if="!isModel">{{ requestParam.bigModel }}</span>
                <template v-else>
                  <el-input v-model="requestParam.bigModel"></el-input>
                  <span class="tips">系统未匹配到正确型号，如抓取错误，请自行调整</span>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="上传类别:" prop="spuCategory">
                <el-select v-model="requestParam.spuCategory" size="mini" @change="querySliceUpFolderTree">
                  <el-option :label="item" :value="item" v-for="item in ['新品', '新品增配', '老品优化', '店铺专供']" :key="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="requestParam.spuCategory == '店铺专供'">
              <el-form-item label="专供店铺:" prop="storeNameText">
                <span>{{ storeNameText }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="上传格式:" prop="uploadType">
                <el-select v-model="requestParam.uploadType" size="mini" @change="importTypeChange">
                  <el-option :label="item" :value="item" v-for="item in uploadTypeList" :key="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="类型:" prop="businessType">
                <el-select v-model="requestParam.businessType" size="mini" @change="businessTypeChange">
                  <el-option label="首次" value="首次" v-if="isFirst"></el-option>
                  <template v-else>
                    <el-option label="修改" value="修改"></el-option>
                    <el-option label="新增" value="新增"></el-option>
                    <el-option label="删除" value="删除"></el-option>
                    <el-option label="全部替换" value="全部替换"></el-option>
                  </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="通知展示:">
                <el-select v-model="requestParam.noticeDisplayList" multiple collapse-tags filterable clearable size="mini" @change="handleNoticeDisplayChange">
                  <el-option label="全部调整" value=""></el-option>
                  <el-option label="工艺调整" value="工艺调整"></el-option>
                  <el-option label="色差调整" value="色差调整"></el-option>
                  <el-option label="尺寸调整" value="尺寸调整"></el-option>
                  <el-option label="材质调整" value="材质调整"></el-option>
                  <el-option label="卖点调整" value="卖点调整"></el-option>
                  <el-option label="新增内容" value="新增内容"></el-option>
                  <el-option label="其他更改" value="其他更改"></el-option>
                  <el-option label="型号升级" value="型号升级"></el-option>
                  <el-option label="删除内容" value="删除内容"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="调整类型:">
                <el-select v-model="requestParam.picAdjustType" multiple collapse-tags filterable clearable size="mini" @change="handlePicAdjustTypeChange">
                  <el-option label="所有图片" value=""></el-option>
                  <el-option label="详情切片" value="详情切片"></el-option>
                  <el-option label="卖点主图" value="卖点主图"></el-option>
                  <el-option label="常规/唯品会销售属性主图" value="常规/唯品会销售属性主图"></el-option>
                  <el-option label="拼多多销售属性主图" value="拼多多销售属性主图"></el-option>
                  <el-option label="天猫三段式销售属性主图" value="天猫三段式销售属性主图"></el-option>
                  <el-option label="无标主图" value="无标主图"></el-option>
                  <el-option label="透明白底" value="透明白底"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-show="showDeleteImageSelector">
              <el-form-item label="删除图片:" prop="deleteImageList">
                <el-button size="mini" type="primary" @click="showDeleteImageDialog = true">请选择需删除的图片</el-button>
                <span class="tips" style="margin-left: 10px" v-if="requestParam.deleteImageList.length">已选择{{ requestParam.deleteImageList.length }}项</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="关联SPU:">
                <section-related-spu-select v-model="requestParam.relationSpu" :request-method="queryAllSpu" />
              </el-form-item>
            </el-col>
            <el-col :span="24" key="editor-part-1">
              <el-form-item label="">
                <div>1.xxx产品型号+规格修改了什么内容涉及到哪些切片和XX主图的切换</div>
                <div class="editor-wrapper">
                  <div ref="editorPart1"></div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24" key="editor-part-2">
              <el-form-item label="">
                <div>2.修改对比图如下：（圈出具体修改部位，左位修改前，右图统一为修改后的）</div>
                <div class="editor-wrapper">
                  <div ref="editorPart2"></div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24" key="editor-part-3">
              <el-form-item label="">
                <div>3.接XX通知修改的这个信息截图：</div>
                <div class="editor-wrapper">
                  <div ref="editorPart3"></div>
                </div>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="24" v-if="requestParam.uploadType == '文件夹' && !isFirst && isFileAdd">
              <el-form-item label="文件夹名称:" prop="folderName" class="pathWidth">
                <el-input size="mini" v-model="requestParam.folderName" maxlength="50"></el-input>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="24" v-if="isImgImport || isFileAdd">
              <el-form-item label="选择路径:" prop="folderNameText" class="pathWidth">
                <el-select v-model="requestParam.folderNameText" ref="mySelect" filterable :filter-method="filterMethod" show-word-limit size="mini">
                  <el-option :value="treeDataValue" style="height: auto">
                    <el-tree
                      ref="tree"
                      :data="nodeData"
                      node-key="id"
                      :props="defaultProps"
                      :filter-node-method="filterNode"
                      default-expand-all
                      :default-expanded-keys="treeExpandDate"
                    >
                      <span slot-scope="{ data }">
                        <div @click.stop="() => handleNodeClick(data)">{{ data.folderName }}</div>
                      </span>
                    </el-tree>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="24" align="left" v-show="!showDeleteImageSelector">
              <el-form-item label="附件:" class="upload-demo">
                <el-upload
                  accept=".jpg,.jpeg,.png,.gif"
                  ref="upload"
                  multiple
                  :limit="9999"
                  action=""
                  :drag="isImgImport"
                  :disabled="disabled"
                  :http-request="httpRequest"
                  :on-remove="handleRemove"
                  :headers="headers"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                >
                  <template v-if="!isImgImport">
                    <el-button slot="trigger" size="small" type="primary" @click="importFile">选取文件夹</el-button>
                    <el-button type="text" style="color: red" size="mini" @click="clearFile">一键清空</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传图片文件，可批量上传</div>
                  </template>
                  <template v-else>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传图片文件，可批量上传</div>
                  </template>
                </el-upload>
                <div class="importBth" v-if="isImgImport">
                  <el-button class="orange-btn" size="mini" @click="checkFormValid">确认上传</el-button>
                  <el-button type="text" style="color: red" size="mini" @click="clearFile">一键清空</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="text-align: center">
          <el-button size="small" type="success" @click="checkFormValid">{{ isFirst ? '首次上传' : '确认上传' }} </el-button>
          <el-button size="small" type="success" @click="handleNotifyOpen">通知店铺上传 </el-button>
          <el-button @click="onCancelImport" size="medium">取 消</el-button>
        </div>
      </div>
    </q-dialog>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
    <!-- 上传通知店铺 -->
    <notify-store-dialog
      :visible.sync="showNotifyDialog"
      v-if="showNotifyDialog"
      :show-platform="true"
      :platform-required="true"
      :platform-options="platformOptions"
      @confirm="handleNotifyConfirm"
    />
    <section-delete-image-dialog
      :visible.sync="showDeleteImageDialog"
      :tree-data="nodeData"
      @confirm="handleDeleteImageConfirm"
    />
    <!-- 上传进度弹窗 -->
    <upload-progress-dialog
      :visible.sync="showUploadProgressDialog"
      :spuId="spuId"
      @close="onUploadProgressClose"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { getToken } from '@/utils/auth';
import E from 'wangeditor';
import imgShow from '@/views/components/imgShow';
import notifyStoreDialog from '@/components/notify-store-dialog/notify-store-dialog';
import uploadProgressDialog from './uploadProgressDialog.vue';
import sectionDeleteImageDialog from './sectionDeleteImageDialog.vue';
import sectionRelatedSpuSelect from './sectionRelatedSpuSelect.vue';
import axios from '@/utils/axiosInstance';
export default {
  name: 'up',
  components: { imgShow, notifyStoreDialog, uploadProgressDialog, sectionDeleteImageDialog, sectionRelatedSpuSelect },
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    spuId: [String, Number],
    spuCode: [String, Number],
    processType: {
      type: Number,
      default: 3,
    },
    //sku有当前节点在切片上
    sectionImportShow: {
      type: Boolean,
      default: false,
    },
    spuName: {
      type: String,
      default: '',
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '切片';
    },
    //判断所有文件是否上传完毕
    allFilesVerified() {
      return this.fileListAll.length && this.fileList.length && this.fileListAll.length === this.fileList.length;
    },
    //获取顶层文件夹名
    topLevelName() {
      if (this.allFilesVerified) {
        var str = this.fileList[0].webkitRelativePath;
        var index = str.indexOf('/');
        var topLevelName = str.substring(0, index);
        return topLevelName;
      } else {
        return '';
      }
    },
    //该文件夹是否为首次上传
    // isFirst() {
    //   return this.tableData.length ? false : true;
    // },
    uploadTypeList() {
      if (this.isFirst) {
        return ['文件夹'];
      } else {
        return ['文件夹'];
        // return ['文件夹', '图片'];
      }
    },
    isImgImport() {
      return this.requestParam.uploadType == '图片';
    },
    isStroe() {
      return +this.productTypeCode === 6;
    },
    showDeleteImageSelector() {
      return this.requestParam.businessType === '删除';
    },
    showPicAdjustTypeSelector() {
      return !this.isFirst;
    }
  },
  watch: {
    isFirst: {
      handler(val) {
        if (val) {
          this.$set(this.requestParam, 'businessType', '首次');
          this.$set(this.requestParam, 'uploadType', '文件夹');
        } else {
          this.$set(this.requestParam, 'businessType', '');
          this.$set(this.requestParam, 'uploadType', '文件夹');
        }
      },
      immediate: true,
    },
    errorType(val) {
      if (val) {
        setTimeout((_) => {
          this.errorType = false;
        }, 2000);
      }
    },
  },
  data() {
    return {
      loading: false,
      isVisibleImport: false,
      addForm: {
        dataType: 2,
      },
      rules: {},
      addForm: {},
      storeList: [],
      tableData: [],
      imgList: [],
      tableReload: true,
      onRemoveSpuIds: [],
      selectSpus: [],
      money: 0,
      requestParam: {
        picAdjustType: [],
        noticeDisplayList: [],
        picAdjustType: [],
        adjustDetailDesc: '',
        adjustContentTypes: [],
        deleteImageList: [],
        relationSpu: [],
        adjustDetailDescPart1: '',
        adjustDetailDescPart2: '',
        adjustDetailDescPart3: '',
      },
      picAdjustTypeOrder: [
        '',
        '工艺调整',
        '色差调整',
        '尺寸调整',
        '材质调整',
        '卖点调整',
        '新增内容',
        '其他更改',
        '型号升级',
        '删除内容',
      ],
      adjustContentTypeOrder: [
        '',
        '详情切片',
        '卖点主图',
        '常规/唯品会销售属性主图',
        '拼多多销售属性主图',
        '天猫三段式销售属性主图',
        '无标主图',
        '透明白底',
      ],
      rules: {
        spuCategory: [{ required: true, message: '不能为空', trigger: 'change' }],
        businessType: [{ required: true, message: '不能为空', trigger: 'change' }],
        uploadType: [{ required: true, message: '不能为空', trigger: 'change' }],
        folderName: [{ required: true, message: '不能为空', trigger: 'change' }],
        folderNameText: [{ required: true, message: '不能为空', trigger: 'change' }],
        deleteImageList: [{
          validator: (rule, value, callback) => {
            if (this.requestParam.businessType === '删除' && (!value || !value.length)) {
              callback(new Error('不能为空'));
              return;
            }
            callback();
          },
          trigger: 'change'
        }],
      },
      headers: {
        Authorization: getToken(),
      },
      fileList: [],
      fileListAll: [],
      fileListImg: [],
      isFirst: true,
      isModel: false,
      fjLoading: false,
      errorType: false,
      disabled: false,
      imgFormVisible: false,
      showNotifyDialog: false,
      isShowAdjustType: true,
      modelList: [],
      treeDataValue: '',
      treeExpandDate: [],
      defaultProps: {
        children: 'children',
        label: 'folderName',
      },
      nodeData: [],
      pathText: '',
      textType: {
        新品: 1,
        新品增配: 2,
        老品优化: 3,
        店铺专供: 6,
      },
      storeNameText: '',
      htmlImgList: [],
      isNotify: false,
      notifyForm: {},
      lastNoticeDisplayList: [],
      lastPicAdjustType: [],
      showUploadProgressDialog: false,
      isModifyVoidMode: false, // 标记是否为修改作废模式
      isShowVoidBtn: false,
      showDeleteImageDialog: false,
      platformOptions: [
        { label: '全部平台', value: 'all' },
      ],
      editorInstances: {},
      businessTypeMap: {
        '首次': '1',
        '新增': '16',
        '修改': '17',
        '删除': '18',
        '全部替换': '19',
      },
    };
  },
  mounted() {
    this.auditOrderInfo();
    this.getSpuStore();
    this.queryPlatformList();
    //暂时取消判断是否展示 都默认展示
    // this.getShowAdjustType();
    this.uploadPopup();
    this.getShowVoidBtn()
  },
  methods: {
    normalizeSliceFolderTree(node) {
      if (!node) return null;
      const children = (node.children || []).map(item => this.normalizeSliceFolderTree(item)).filter(Boolean);
      const fileNodes = (node.fileList || []).map(file => ({
        id: file.id,
        folderId: file.folderId,
        folderName: file.fileName,
        fileName: file.fileName,
        fileUrl: file.fileUrl,
        isFileLeaf: true,
        children: [],
      }));
      return {
        id: node.id,
        folderId: node.id,
        folderName: node.folderName,
        parentId: node.parentId,
        folderLevel: node.folderLevel,
        isFileLeaf: false,
        children: [...children, ...fileNodes],
      };
    },
    resetRequestParamFields() {
      this.requestParam.picAdjustType = [];
      this.requestParam.noticeDisplayList = [];
      this.requestParam.picAdjustType = [];
      this.requestParam.adjustDetailDesc = '';
      this.requestParam.adjustContentTypes = [];
      this.requestParam.deleteImageList = [];
      this.requestParam.relationSpu = [];
      this.requestParam.adjustDetailDescPart1 = '';
      this.requestParam.adjustDetailDescPart2 = '';
      this.requestParam.adjustDetailDescPart3 = '';
      this.lastNoticeDisplayList = [];
      this.lastPicAdjustType = [];
    },
    normalizeAllSelectedValues(currentValue = [], previousValue = []) {
      const currentList = Array.isArray(currentValue) ? currentValue.slice() : [];
      const previousList = Array.isArray(previousValue) ? previousValue.slice() : [];
      const currentHasAll = currentList.includes('');
      const previousHasAll = previousList.includes('');
      if (!currentHasAll) {
        return currentList;
      }
      if (!previousHasAll) {
        return [''];
      }
      if (currentList.length > 1) {
        return currentList.filter(item => item !== '');
      }
      return [''];
    },
    expandAllSelectedValues(list = [], optionOrder = []) {
      const currentList = Array.isArray(list) ? list.slice() : [];
      if (!currentList.includes('')) {
        return currentList;
      }
      return optionOrder.filter(item => item);
    },
    initEditor(refName = 'editorPart1', fieldName = 'adjustDetailDescPart1') {
      setTimeout(() => {
        const targetRef = this.$refs[refName];
        if (!targetRef) return;
        if (this.editorInstances[refName]) {
          this.editorInstances[refName].destroy();
          this.editorInstances[refName] = null;
        }
        let editor = new E(targetRef);
        editor.config.menus = ['image'];
        editor.config.onchange = (html) => {
          this.requestParam[fieldName] = html + '';
          this.htmlImgList = this.htmlImgList.filter((v) => this.requestParam[fieldName].includes(v));
        };
        editor.config.placeholder = '';
        editor.config.uploadImgMaxSize = 10 * 1024 * 1024;
        editor.config.uploadFileName = 'file';
        editor.config.uploadImgMaxLength = 1;
        editor.config.uploadVideoAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
        editor.config.showLinkImg = false;
        editor.config.maxLength = 500;
        editor.config.uploadImgHeaders = {
          'Access-Control-Allow-Origin': 'origin',
          Authorization: getToken,
        };
        editor.txt.eventHooks.imgClickEvents.push(this.imgClick);
        editor.config.customUploadImg = async (files, insert) => {
          if (this.htmlImgList.length == 100) {
            this.$message.error('最多上传100张图片！');
            return;
          }
          const form = new FormData();
          form.append('file', files[0]);
          form.append('appCode', 'ec-pc-new');
          fetch('https://upload.quanyou.com.cn/gw/qu-file-upload-api/upload/app/uploadFile', {
            method: 'POST',
            body: form,
            mode: 'cors',
          })
            .then((response) => response.json())
            .then((res) => {
              if (res.success) {
                this.htmlImgList.push(res.data.fileUrl);
                insert(res.data.fileUrl);
              } else {
                this.$message.error(res.message);
              }
            });
        };
        editor.create();
        editor.txt.html(this.requestParam[fieldName] || '<p></p>');
        this.editorInstances[refName] = editor;
      }, 300);
    },
    ensureEditors() {
      const editorConfigList = [
        { refName: 'editorPart1', fieldName: 'adjustDetailDescPart1' },
        { refName: 'editorPart2', fieldName: 'adjustDetailDescPart2' },
        { refName: 'editorPart3', fieldName: 'adjustDetailDescPart3' },
      ];
      editorConfigList.forEach(({ refName, fieldName }) => {
        const targetRef = this.$refs[refName];
        if (!targetRef) return;
        const hasEditorDom = !!targetRef.querySelector('.w-e-text-container');
        if (!this.editorInstances[refName] || !hasEditorDom) {
          if (this.editorInstances[refName]) {
            this.editorInstances[refName].destroy();
            this.editorInstances[refName] = null;
          }
          this.initEditor(refName, fieldName);
        }
      });
    },
    //获取当前spu 大型号 图片树形
    async uploadPopup() {
      let res = await this.$q.newProduct.uploadPopup({
        fragment: [this.spuId],
      });
      this.$set(this.requestParam, 'bigModel', res.data.bigModel);
      this.$set(this.requestParam, 'spuCategory', res.data.spuCategory);
      this.isFirst = res.data.isForFirst === '是';
      this.isModel = res.data.bigModel === '未匹配';
      this.querySliceUpFolderTree();
    },
    async querySliceUpFolderTree() {
      const uploadCategory = this.textType[this.requestParam.spuCategory];
      if (!uploadCategory) return;
      const res = await this.$q.newProduct.querySliceUpFolderTree({
        data: {
          spuId: String(this.spuId),
          uploadCategory
        }
      });
      if (res && res.success && res.data) {
        const treeNode = this.normalizeSliceFolderTree(res.data);
        this.nodeData = treeNode ? [treeNode] : [];
      }
    },
    queryAllSpu(keyword = '') {
      return this.$q.common.reportsData({
        fragment: ['queryAllSpu'],
        data: {
          pageSize: 50,
          pageNum: 1,
          param: {
            spuName: keyword
          }
        }
      }).then((res) => {
        return ((res.data && res.data.list) || []).map(item => ({
          spuCode: item.spuCode,
          spuName: item.spuName
        }));
      });
    },
    queryPlatformList() {
      this.$q.common.reportsData({
        data: {
          pageSize: 50,
          pageNum: 1,
          reportCode: 'queryPlatformList',
          param: {},
          queryMatch: [],
          orderList: [],
          hasCount: 'N',
          groupAttr: ''
        }
      }).then((res) => {
        const list = ((res.data && res.data.list) || []).map(item => ({
          label: item.platformname,
          value: item.platformname
        }))
        this.platformOptions = [{ label: '全部平台', value: 'all' }, ...list];
        console.log(this.platformOptions);
      });
    },
    getShowVoidBtn() {
      const data = new FormData()
      data.append('spuCode',this.spuCode)
      this.$q.newProduct.getShowVoidBtn({data: data}).then(res => {
        this.isShowVoidBtn = res.data
      })
    },
    onCancel() {
      this.isVisible = false;
    },
    onCancelImport() {
      this.isVisibleImport = false;
      this.fileList = [];
      this.fileListAll = [];
      this.resetRequestParamFields();
      Object.keys(this.editorInstances).forEach((key) => {
        if (this.editorInstances[key]) {
          this.editorInstances[key].destroy();
          this.editorInstances[key] = null;
        }
      });
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
      });
    },
    // 搜索逻辑
    filterMethod(value) {
      this.$refs.tree.filter(value);
    },
    // tree节点过滤
    filterNode(value, data) {
      if (!value) return true;
      return data.folderName.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      this.requestParam.folderId = data.id;
      this.pathText = this.getItemByIdInTree(this.nodeData, data.id);
      this.$set(this.requestParam, 'folderNameText', data.folderName);
      this.treeDataValue = data;
      this.$refs.mySelect.handleClose();
      this.changePath();
    },
    getItemByIdInTree(tree, value, path = '') {
      for (var i = 0; i < tree.length; i++) {
        let tempPath = path;
        tempPath = `${tempPath ? tempPath + '/' : tempPath}${tree[i].folderName}`; // 避免出现在最前面的/
        if (tree[i].id == value) {
          return tempPath;
        } else if (tree[i].children) {
          let reuslt = this.getItemByIdInTree(tree[i].children, value, tempPath);
          if (reuslt) {
            return reuslt;
          }
        }
      }
    },
    importTypeChange(val) {
      if (val == '图片') {
        this.$refs.upload.$children[0].$refs.input.webkitdirectory = false;
      } else {
        this.$nextTick(() => {
          this.$refs.upload.$children[0].$refs.input.webkitdirectory = true;
        });
      }
      this.fileList = [];
      this.fileListAll = [];
    },
    changePath() {
      // this.fileList = [];
      // this.fileListAll = [];
    },
    importExcel() {
      this.isVisibleImport = true;
      this.resetRequestParamFields();
      if (this.isFirst) {
        this.requestParam.businessType = '首次';
        this.requestParam.picAdjustType = [];
        this.requestParam.adjustContentTypes = [];
        this.requestParam.deleteImageList = [];
      }
      this.$nextTick((_) => {
        if (this.isImgImport) {
          this.$refs.upload.$children[0].$refs.input.webkitdirectory = false;
        } else {
          this.$refs.upload.$children[0].$refs.input.webkitdirectory = true;
        }
        this.ensureEditors();
      });
    },
    download(row) {
      let _this = this;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const data = {
        processType: this.processType,
        folderName: row.folderName,
        spuId: this.spuId,
      };
      this.$q.newProduct.pictureDownload({ data: data }).then((res) => {
        var timer = setInterval(function () {
          _this.$q.common
            .reportTaskInfo({ fragment: [res.message] })
            .then((res) => {
              if (res.data.taskStatus == '执行完成') {
                clearInterval(timer);
                loading.close();
                _this.downloadRes(res.data.filePath, row.folderName);
              }
            })
            .catch((err) => {
              loading.close();
              this.$message.error(err.message);
            });
        }, 5000);
      });
    },
    async downloadRes(url, fileName) {
      let response = await fetch(url, { mode: 'cors' });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = objectUrl;
      a.download = fileName + '' + url.substring(url.lastIndexOf('.'));
      a.click();
      a.remove();
    },
    auditOrderInfo() {
      this.loading = true;
      this.$q.newProduct
        .getUploadDetail({ fragment: [this.spuId] })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getSpuStore() {
      let params = {
        params: {
          spuCode: this.spuCode,
        },
      };
      this.$q.newProduct.getSpuStore(params).then((res) => {
        this.storeNameText = res.data.map((v) => v.storeName).join(',');
      });
    },
    //是否展示调整类型
    getShowAdjustType() {
      let params = {
        params: {
          spuCode: this.spuCode,
        },
      };
      this.$q.newProduct.getShowAdjustType(params).then((res) => {
        this.isShowAdjustType = res.data;
      });
    },

    importFile(event) {
      this.errorType = false;
      if (this.fileList.length) {
        this.$message.error(`一次仅上传一个${this.title}文件夹`);
        this.disabled = true;
        setTimeout(() => {
          this.disabled = false;
        }, 20);
        return;
      }
    },

    handleRemove(file, fileList) {
      if (this.errorType) {
        this.fileList = [];
        return;
      }
      this.fileList = fileList;
      let fileNameList = fileList.map((item) => item.uid);
      this.fileListImg = this.fileListImg.filter((item) => {
        return fileNameList.includes(item.file.uid);
      });
    },
    httpRequest(file) {},
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.onCancel();
    },
    // 验证
    beforeUpload(file) {
      if (this.errorType) {
        this.fileList = [];
        // this.errorType = false;
        return false;
      }
      let pattern = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      if (pattern != 'db' && pattern != 'ds_store') {
        //排除隐藏.db系统文件
        this.fileListAll.push(file);
      }
      //一层文件夹名称
      let pathText = this.requestParam.uploadType == '图片' ? this.pathText : file.webkitRelativePath;
      let importType = pathText.split('/')[1];
      // if (!this.requestParam.folderNameText && (this.isImgImport || this.isFileAdd)) {
      //   this.errorType = true;
      //   this.$message.error('请先选择路径！');
      //   return false;
      // }
      // if (this.spuName != pathText.split('/')[0]) {
      //   this.errorType = true;
      //   this.$message.error('顶层文件夹名必须为SPU名称！');
      //   return false;
      // } else
      // if (pattern != 'png' && pattern != 'jpg' && pattern != 'db' && pattern != 'ds_store' && importType == '主图' && pathText.includes('透明白底')) {
      //   this.errorType = true;
      //   this.$message.error('二级主图三级(透明白底)图片格式为png/jpg！');
      //   return false;
      // } else if (pattern != 'png' && pattern != 'jpg' && pattern != 'db' && pattern != 'ds_store' && importType == '主图' && pathText.includes('唯品会')) {
      //   this.errorType = true;
      //   this.$message.error('二级主图三级(唯品会)图片格式为png/jpg！');
      //   return false;
      // } else if (
      //   pattern != 'jpg' &&
      //   pattern != 'jpeg' &&
      //   pattern != 'db' &&
      //   pattern != 'ds_store' &&
      //   importType == '主图' &&
      //   !pathText.includes('透明白底') &&
      //   !pathText.includes('唯品会')
      // ) {
      //   this.errorType = true;
      //   this.$message.error('二级主图文件夹下其它三级文件夹（除透明白底/唯品会）下图片格式为jpg');
      //   return false;
      // } else if (pattern != 'gif' && pattern != 'jpg' && pattern != 'jpeg' && pattern != 'db' && pattern != 'ds_store' && importType == '切片') {
      //   this.errorType = true;
      //   this.$message.error('切片文件夹为下格式为gif/jpg');
      //   return false;
      // }
      if (!this.errorType && pattern != 'db' && pattern != 'ds_store') {
        this.fileList.push(file);
        //上传类型为图片时记录当前图片是属于那个路径下 进行批量分类上传  文件夹新增时也按图片方式传参
        if (this.isImgImport) {
          this.fileListImg.push({
            fileId: this.requestParam.folderId,
            file: file,
          });
        }
      }
    },
    checkFormValid(file) {
      if (this.requestParam.picAdjustType && this.requestParam.picAdjustType.length) {
        this.requestParam.picAdjustType = this.sortPicAdjustType(this.requestParam.picAdjustType);
      }
      if (this.requestParam.noticeDisplayList && this.requestParam.noticeDisplayList.length) {
        this.requestParam.noticeDisplayList = this.sortPicAdjustType(this.requestParam.noticeDisplayList);
      }
      if (this.requestParam.adjustContentTypes && this.requestParam.adjustContentTypes.length) {
        this.requestParam.adjustContentTypes = this.sortAdjustContentType(this.requestParam.adjustContentTypes);
      }
      if (this.requestParam.picAdjustType && this.requestParam.picAdjustType.length) {
        this.requestParam.picAdjustType = this.sortAdjustContentType(this.requestParam.picAdjustType);
      }
      this.$refs['requestParam'].validate((valid) => {
        if (valid) {
          this.submitUpload(file);
        } else {
          this.$message.error('参数校验失败！');
        }
      });
    },
    sortPicAdjustType(list) {
      const currentList = Array.isArray(list) ? list.slice() : [];
      return currentList.sort((a, b) => {
        const indexA = this.picAdjustTypeOrder.indexOf(a);
        const indexB = this.picAdjustTypeOrder.indexOf(b);
        const sortA = indexA === -1 ? Number.MAX_SAFE_INTEGER : indexA;
        const sortB = indexB === -1 ? Number.MAX_SAFE_INTEGER : indexB;
        return sortA - sortB;
      });
    },
    sortAdjustContentType(list) {
      const currentList = Array.isArray(list) ? list.slice() : [];
      return currentList.sort((a, b) => {
        const indexA = this.adjustContentTypeOrder.indexOf(a);
        const indexB = this.adjustContentTypeOrder.indexOf(b);
        const sortA = indexA === -1 ? Number.MAX_SAFE_INTEGER : indexA;
        const sortB = indexB === -1 ? Number.MAX_SAFE_INTEGER : indexB;
        return sortA - sortB;
      });
    },
    handleDeleteImageConfirm(list) {
      this.requestParam.deleteImageList = (list || []).filter(item => item.isFileLeaf);
      this.$nextTick(() => {
        this.$refs.requestParam && this.$refs.requestParam.validateField('deleteImageList');
      });
    },
    buildMergedAdjustDetailDesc() {
      const sections = [
        {
          title: '1.xxx产品型号+规格：修改了“什么内容”涉及到哪些切片和XX主图的替换',
          content: this.requestParam.adjustDetailDescPart1
        },
        {
          title: '2.修改对比图如下：（圈出具体修改部位，左位修改前，右图统一为修改后的）',
          content: this.requestParam.adjustDetailDescPart2
        },
        {
          title: '3.接XX通知修改的这个信息截图',
          content: this.requestParam.adjustDetailDescPart3
        }
      ];
      return sections
        .filter(item => item.content)
        .map(item => `<p>${item.title}</p>${item.content}`)
        .join('<hr/>');
    },
    buildNoticePayload(baseData = {}) {
      const mergedAdjustDetailDesc = this.buildMergedAdjustDetailDesc();
      const { noticeDisplayList, picAdjustType, bigModel, businessType, relationSpu } = this.requestParam;
      const { platformList, receivePlatform, ...restBaseData } = baseData;
      const expandedNoticeDisplay = noticeDisplayList && noticeDisplayList.length
        ? this.expandAllSelectedValues(noticeDisplayList, this.picAdjustTypeOrder).join(',')
        : '';
      const expandedPicAdjustType = picAdjustType && picAdjustType.length
        ? this.expandAllSelectedValues(picAdjustType, this.adjustContentTypeOrder).join(',')
        : '';
      return {
        ...restBaseData,
        spuCode: this.spuCode,
        picAdjustType: expandedPicAdjustType,
        noticeDisplay: expandedNoticeDisplay,
        receivePlatform: receivePlatform || platformList || '',
        relationSpu: relationSpu && relationSpu.length ? relationSpu.join(',') : '',
        adjustDetailDesc: mergedAdjustDetailDesc,
        adjustContent: '设计图',
        productModel: bigModel,
        businessType,
        isImport: 0,
      };
    },
    clearFile() {
      this.fileListImg = [];
      this.fileList = [];
    },
    handleNotifyOpen() {
      this.$refs['requestParam'].validate((valid) => {
        if (valid) {
          if (!this.showDeleteImageSelector && (!this.fileList || this.fileList.length === 0)) {
            this.$message.error('请先上传图片');
            return;
          }
          this.notifyForm = {
            platformList: ['all']
          };
          this.showNotifyDialog = true;
          this.isNotify = false;
        } else {
          this.$message.error('参数校验失败！');
        }
      });
    },
    handleNotifyConfirm(data) {
      // 判断是修改作废模式还是上传通知模式
      if (this.isModifyVoidMode) {
        this.isModifyVoidMode = false; // 重置标志
        const params = this.buildNoticePayload({
          adjustContent: '设计图作废',
          operType: '通知',
          ...data
        });
        this.notificationLog(params)
        this.$q.goods
          .saveMsgNotice({ data: params })
          .then((res) => {
            if (res.success) {
              this.$message.success('修改作废成功');
              this.getShowVoidBtn();
              if(this.notifyForm.noticeTime == 0){
                this.$store.dispatch('menu/getMenusNum', {}, {root: true})
              }
            }
          })
      } else {
        this.notifyForm = data;
        this.isNotify = true;
        this.checkFormValid();
      }
    },
    submitUpload(file) {
      if (!this.showDeleteImageSelector && (!this.fileList || this.fileList.length === 0)) {
        this.$message.error('请先上传图片');
        return;
      }
      const mergedAdjustDetailDesc = this.buildMergedAdjustDetailDesc();
      const form = new FormData();
      const _this = this;
      var pathInfo = [];
      var secondaryFileName = [];
      var secondaryFileNameAll = ['主图', '切片'];
      form.append('bigModel', this.requestParam.bigModel);
      form.append('uploadCategory', this.textType[this.requestParam.spuCategory]);
      // this.isFileAdd && form.append('folderName', this.requestParam.folderName);
      form.append('spuId', this.spuId);
      form.append('businessType', this.businessTypeMap[this.requestParam.businessType] || this.requestParam.businessType);
      form.append('uploadFormat', this.isImgImport ? 2 : 1);
      form.append('isNotice', this.isNotify ? 1 : 0);
      form.append('adjustType', this.expandAllSelectedValues(this.requestParam.picAdjustType, this.adjustContentTypeOrder).join(','));
      form.append('adjustContentTypes', (this.requestParam.adjustContentTypes || []).join(','));
      form.append('deleteFileIds', (this.requestParam.deleteImageList || []).map(item => item.id).join(','));
      if (!this.showDeleteImageSelector) {
        this.fileList.forEach((v) => {
          form.append('files', v);
          const relativePath = v.webkitRelativePath || '';
          const pathParts = relativePath.split('/').filter(Boolean);
          if (pathParts.length > 1 && !relativePath.includes('ds_store')) {
            secondaryFileName.push(pathParts[1]);
          }
        });
      }
      //为图片类型时
      if (this.isImgImport) {
        pathInfo = this.fileListImg.map((v) => {
          return {
            fileId: v.fileId,
            fileName: v.file.name,
          };
        });
        form.append('pathInfo', JSON.stringify(pathInfo));
      }
      //店铺通知时传入
      let msgNotice = {
        ...this.buildNoticePayload(this.notifyForm),
        operType: '通知'
      }
      form.append('msgNotice', this.isNotify ? JSON.stringify(msgNotice) : '');
      form.append('adjustDetailDesc', mergedAdjustDetailDesc);


      secondaryFileName = [...new Set(secondaryFileName)];
      if (!this.showDeleteImageSelector && !this.fileList.length) {
        this.$message.error('请确认文件夹上传规范是否正确！');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '图片上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)',
      });
      this.$q.newProduct
        .sliceUpload({ data: form })
        .then((res) => {
          if (res.code == 200) {
              _this.$message.success('上传中，上传结果请到“切片”弹窗内“上传进度”查看');
              _this.isVisible = false;
              _this.$emit('success');
              loading.close();
              _this.isNotify = false
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((_) => {
          loading.close();
        });
    },
    notifyStore() {
      this.isNotify = false
      let data = {
        ...this.buildNoticePayload(this.notifyForm),
        operType: '通知'
      };
      this.notificationLog(data)
      this.$q.goods
        .saveMsgNotice({ data: data })
        .then((res) => {
          if (res.success) {
            if(this.notifyForm.noticeTime == 0){
              this.$store.dispatch('menu/getMenusNum', {}, {root: true})
            }
          }
        })
    },
    notificationLog(data) {
      this.$q.goods.msgNoticeSaveLog({ data: data })
    },
    // 打开上传进度弹窗
    openUploadProgress() {
      this.showUploadProgressDialog = true;
    },
    // 关闭上传进度弹窗
    onUploadProgressClose() {
      this.showUploadProgressDialog = false;
    },
    // 修改作废按钮点击
    handleModifyVoidClick() {
      this.$confirm('确认后，将会作废上一条设计图变更消息通知，并重新给店铺发送一条设计图作废通知', '修改作废', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 二次确认后打开通知店铺弹窗（复用现有组件）
        this.isModifyVoidMode = true;
        this.showNotifyDialog = true;
      }).catch(() => {
        // 用户取消
      });
    },
    businessTypeChange(val) {
      if (val !== '删除') {
        this.requestParam.deleteImageList = [];
      }
      if (val === '首次') {
        this.requestParam.noticeDisplayList = [];
      }
      if (val === '新增') {
        this.requestParam.adjustContentTypes = [];
      }
      if (val !== '修改') {
        this.requestParam.adjustContentTypes = [];
      }
      if (val === '删除') {
        this.fileList = [];
        this.fileListAll = [];
        this.fileListImg = [];
      }
      if (val !== '修改' && val !== '新增' && val !== '全部替换') {
        this.requestParam.picAdjustType = [];
      }
      if (val === '新增' || val === '全部替换') {
        this.requestParam.deleteImageList = [];
      }
      this.$nextTick(() => {
        this.ensureEditors();
      });
    },
    handleNoticeDisplayChange(value) {
      const normalizedValue = this.normalizeAllSelectedValues(value, this.lastNoticeDisplayList);
      this.requestParam.noticeDisplayList = normalizedValue;
      this.lastNoticeDisplayList = normalizedValue.slice();
    },
    handlePicAdjustTypeChange(value) {
      const normalizedValue = this.normalizeAllSelectedValues(value, this.lastPicAdjustType);
      this.requestParam.picAdjustType = normalizedValue;
      this.lastPicAdjustType = normalizedValue.slice();
    }
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-dialog {
  margin-top: 50px !important;
}

.content >>> .el-date-editor.el-input__inner, .content >>> .el-select, .content >>> .el-input {
  width: 240px !important;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}

.content {
  max-height: 70vh;
  overflow-y: auto;
}

.right50 {
  margin-right: 50px;
}

.footer {
  margin: 15px 0 5px 0;
  text-align: center;
}

// >>> .el-upload-list {
// max-height: 50vh
// overflow-y: auto
// }
.pathWidth >>>.el-input {
  width: 300px;
}

>>> .el-form-item {
  margin-bottom: 15px;
}

>>> .el-form-item__content {
  line-height: 28px;
}

.upload-demo {
  position: relative;
}

.importBth {
  position: absolute;
  top: 145px;
  right: 10px;
}

.popoverBOx {
  max-height: 70vh;
  overflow-y: auto;
}

.tips {
  color: red;
  margin-left: 10px;
}

.editor-wrapper >>> .w-e-text-container {
  height: 150px !important;
}

.editor-wrapper >>> .w-e-text {
  min-height: 150px !important;
}
</style>
